// /images 업로드 상태 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

// 업로드 상태(uploadStatus)
export const uploadStatusMeta: Record<string, StatusMeta> = {
  NONE: { label: "NONE", color: "default" },
  PENDING: { label: "PENDING", color: "warning" },
  COMPLETE: { label: "COMPLETE", color: "success" },
};

// 매핑에 없는 값도 안전하게 표시
export const resolveStatusMeta = (
  map: Record<string, StatusMeta>,
  value: unknown
): StatusMeta => {
  const key = value === null || value === undefined ? "" : String(value);
  return map[key] ?? { label: key || "-", color: "default" };
};
